import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const CtaSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-background">
      <div className="max-w-6xl mx-auto px-4 lg:px-8">
        {/* Main CTA */}
        <div className="relative overflow-hidden rounded-3xl p-10 md:p-14 text-center" style={{ background: 'linear-gradient(to bottom right, #F58A54, #F06F6B, #E0528A)' }}>
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-white/5 blur-2xl" />
            <div className="absolute -bottom-16 -left-16 w-64 h-64 rounded-full bg-white/5 blur-2xl" />
          </div>
          <div className="relative">
            <div className="w-16 h-16 rounded-2xl bg-white/15 flex items-center justify-center mx-auto mb-6">
              <Icon name="Zap" size={28} color="white" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Ready to get started?
            </h2>
            <p className="text-white/75 text-lg max-w-xl mx-auto mb-8">
              Create your first Stack today and receive quotes from verified vendors.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button
                onClick={() => navigate('/create-project-flow')}
                className="px-8 py-3.5 bg-white text-primary font-semibold rounded-xl hover:bg-white/90 transition-all duration-200 shadow-lg hover:shadow-xl hover:-translate-y-0.5"
              >
                Create Your Stack
              </button>
              <button
                onClick={() => navigate('/vendor-quote-request-landing')}
                className="px-8 py-3.5 bg-white/10 backdrop-blur-sm border border-white/30 text-white font-semibold rounded-xl hover:bg-white/20 transition-all duration-200"
              >
                I'm a Vendor
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
